import { ConfigProvider } from 'antd';
import { FC } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './components/App/App';
import './index.css';
import ru from './locale';
import { persistor, store } from './store/store';
import { useAxiosHeaders } from './utils/http';

const AppWrapper: FC = () => {
  useAxiosHeaders();

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ConfigProvider locale={ru}>
            <App />
          </ConfigProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(
  <Provider store={store}>
    <AppWrapper />
  </Provider>,
);
